module.exports = __webpack_public_path__ + "img/r4c2.1ae45e50.jpg";